/**
 * Legacy localStorage cleanup for the retired PKCE flow.
 *
 * Cookie sessions are now authoritative, but we still clear the old keys on
 * logout and bootstrap failure so stale browser state cannot survive upgrades.
 */

const KEYS = {
  accessToken: 'chatbot_access_token',
  idToken: 'chatbot_id_token',
  refreshToken: 'chatbot_refresh_token',
  expiresAt: 'chatbot_expires_at',
}

export interface StoredTokens {
  accessToken: string
  idToken?: string
  refreshToken?: string
  expiresAt: number
}

export function clearTokens(): void {
  Object.values(KEYS).forEach((key) => localStorage.removeItem(key))
}
